// extracted by mini-css-extract-plugin
export default {"wrapper":"Emoji-module__wrapper___fCa4F"};